export const VERSION = '0.7.2';
